import { FieldName, IErrorMessage, ValidationErrorType } from "./validatorMessage.interface";

// #region Error-Message-Arrays for different form fields
// Note: DYNAMIC_MAX_LENGTH  & DYNAMIC_MIN_LENGTH must be replaced dynamically in the component

/** Prefix Mr/Ms/Divers */
const PREFIX_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Default_Validate_required' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_Default_Validate_Letters_Pattern' },
  { type: ValidationErrorType.MaxLength, message: 'MAX_LENGTH' }
];
/** Lastname */
const LASTNAME_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Lastname_Validate_Required' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_Default_Validate_Letters_Pattern' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
/** Firstname */
const FIRSTNAME_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Name_Validate_Required' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_Default_Validate_Letters_Pattern' },
  { type: ValidationErrorType.MinLength, message: 'DYNAMIC_MIN_LENGTH' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
/** Email */
const EMAIL_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Default_Validate_required' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_Phone_Validate_Email' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
/**  Street & HouseNumber are validated together as Address*/
const ADDRESS_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Address_Validate_Required' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_Address_Validate_Pattern' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
/** Street */
const STREET_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Street_Required' },
  { type: ValidationErrorType.MinLength, message: 'phDataInputs_Default_MinLength' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_Street_Pattern' }
];
/* HouseNumber*/
const HOUSENUMBER_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Default_Validate_required' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_House_Number_Pattern' }
]
/** ZipCode */
const ZIPCODE_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Zip_code_Validate_Required' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_Zip_code_Validate_Pattern' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
/** City */
const CITY_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_City_Validate_Required' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_City_Validate_Pattern' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
/** Country */
const COUNTRY_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Country_Validate_Required' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_Default_Validate_Letters_Pattern' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
/**Addition */
const ADDITION_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Addition_Validate_Required' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
/** CareOf */
const CAREOF_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Co_Validate_Required' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
const TELEPHONE_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phPhoneInput_Phone_Validate_MinLength' },
  { type: ValidationErrorType.Pattern, message: 'phDataInputs_Phone_Validate_Pattern' },
  { type: ValidationErrorType.MaxLength, message: 'DYNAMIC_MAX_LENGTH' }
];
/**Birthdate */
const BIRTHDATE_ERROR_MESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_bday_ymd_Validate_Required' },
  { type: ValidationErrorType.DateInvalid, message: 'phDataInputs_bday_ymd_DateNotValid' }
];
/** default: 'This field can not be empty' */
export const DEFAULT_ERRORMESSAGES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phDataInputs_Default_Validate_required' }
];

/** IH Order group and member name */
const INHOUSE_GROUPORDER_NAME_VALIDATION_RULES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phGroupOrder_Input_Validate_Name' },
  { type: ValidationErrorType.NoWhitespaceOnly, message: 'phGroupOrder_Input_Validate_Name' },
  { type: ValidationErrorType.MinLength, message: 'phGroupOrder_Input_Validate_Length' },
  { type: ValidationErrorType.Pattern, message: 'phGroupOrder_Input_Validate_Characters' },
  { type: ValidationErrorType.ForbiddenName, message: 'phGroupOrder_Input_Validate_Forbbiden_UserName' }
];

/** Remote order group and member name */
const REMOTE_ORDER_NAME_VALIDATION_RULES: IErrorMessage[] = [
  { type: ValidationErrorType.Required, message: 'phRemoteOrder_Input_Validate_Name_required' },
  { type: ValidationErrorType.NoWhitespaceOnly, message: 'phRemoteOrder_Input_Validate_Name_required' },
  { type: ValidationErrorType.MinLength, message: 'phRemoteOrder_Input_Validate_Name_minlength' },
  { type: ValidationErrorType.Pattern, message: 'phRemoteOrder_Input_Validate_Name_pattern' },
  { type: ValidationErrorType.ForbiddenName, message: 'phRemoteOrder_Input_Validate_Name_forbiddenName' }
];

//#endregion

//#region Exported Error Message Collections

/**Error Messages for Dynamic Fields */
export const DYNAMICFIELD_ERROR_MESSAGES: { [key: string]: IErrorMessage[] } = {
  [FieldName.Prefix]: PREFIX_ERROR_MESSAGES,
  [FieldName.Lastname]: LASTNAME_ERROR_MESSAGES,
  [FieldName.FirstName]: FIRSTNAME_ERROR_MESSAGES,
  [FieldName.Email]: EMAIL_ERROR_MESSAGES,
  [FieldName.Address]: ADDRESS_ERROR_MESSAGES,
  [FieldName.ZipCode]: ZIPCODE_ERROR_MESSAGES,
  [FieldName.City]: CITY_ERROR_MESSAGES,
  [FieldName.Country]: COUNTRY_ERROR_MESSAGES,
  [FieldName.Addition]: ADDITION_ERROR_MESSAGES,
  [FieldName.CareOf]: CAREOF_ERROR_MESSAGES,
  [FieldName.Telephone1]: TELEPHONE_ERROR_MESSAGES,
  [FieldName.Telephone2]: TELEPHONE_ERROR_MESSAGES,
  [FieldName.TelephoneMobile]: TELEPHONE_ERROR_MESSAGES,
  [FieldName.BirthDate]: BIRTHDATE_ERROR_MESSAGES,
};

/** Error Messages for Inhouse Group Order Name Fields */
export const INHOUSE_GROUPORDER_NAME_ERROR_MESSAGES: { [key: string]: IErrorMessage[] } = {
  [FieldName.UserName]: INHOUSE_GROUPORDER_NAME_VALIDATION_RULES,
  [FieldName.GroupName]: INHOUSE_GROUPORDER_NAME_VALIDATION_RULES
};

/** Error Messages for Remote Group Order Name Fields */
export const REMOTE_GROUPORDER_NAME_ERROR_MESSAGES: { [key: string]: IErrorMessage[] } = {
  [FieldName.UserName]: REMOTE_ORDER_NAME_VALIDATION_RULES,
  [FieldName.GroupName]: REMOTE_ORDER_NAME_VALIDATION_RULES
};

/** Error Messages for Delivery Address Fields */
export const DELIVERY_ADDRESS_FIELD_ERROR_MESSAGES: { [key: string]: IErrorMessage[] } = {
  [FieldName.ZipCode]: ZIPCODE_ERROR_MESSAGES,
  [FieldName.City]: CITY_ERROR_MESSAGES,
  [FieldName.Street]: STREET_ERROR_MESSAGES,
  [FieldName.HouseNumber]: HOUSENUMBER_ERROR_MESSAGES,
};
//#endregion
